const getDynamicFilterOptions = (data, key) => {
  const uniqueValues = new Set();
  data.forEach((record) => {
    const value = key.split(".").reduce((acc, part) => acc?.[part], record);
    if (value) {
      // Ensure the key exists and has a value
      uniqueValues.add(value);
    }
  });
  return Array.from(uniqueValues);
};

export default { getDynamicFilterOptions };
